const { makeStyles } = require("@material-ui/core");

export const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 15,
  },
  card: {
    background: "#fff",
    width: "100%",
    height: "100%",
    borderRadius: 10,
    padding: 18,
    textAlign: "center",
  },
  demoCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  demoCardHeader: {
    textAlign: "center",
  },
  calendar: {
    position: "relative",
    marginTop: 15,
  },
  formWrap: {
    paddingTop: 18,
  },
  slotCard: {
    padding: "12px",
    backgroundColor: "#fff",
    borderRadius: 8,
    cursor: "pointer",
    "&:not(:last-child)": {
      marginBottom: "12px",
    },
    border: "1px solid #f0e7e7",
  },
  selected: {
    border: "2px solid #0a0a29",
  },
  slotWrap: {
    marginTop: 15,
  },
  formActions: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: 18,
  },
  emailWrap: {
    maxWidth: 400,
    margin: "0 auto",
    marginTop: 18,
  },
  emailWrapActions: {
    marginTop: 18,
  },
  backContainer: {
    margin: `18px 0px`,
  },
}));
